import { useEffect } from 'react';
import {
  Outlet,
  ScrollRestoration,
  useNavigation,
  useRouteError,
} from 'react-router';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { FullScreenError, FullScreenSpinner } from '~/components/FullScreen';
import { addError } from '~/utils/datadog-error';
import { useGATrackPage } from '~/useGATrackPage';

export function Component() {
  useGATrackPage();

  return (
    <>
      <ScrollRestoration />
      <LoadingOutlet />
    </>
  );
}

export function HydrateFallback() {
  const { t } = useTranslation();
  return <FullScreenSpinner message={t('ui.io.loading')} />;
}

export function ErrorBoundary() {
  const { t } = useTranslation();
  const error = useRouteError();

  useEffect(() => {
    addError(error);
  }, [error]);

  return <FullScreenError message={t('ui.io.invite.error.generic_error')} />;
}

function LoadingOutlet() {
  const navigation = useNavigation();
  const { t } = useTranslation();

  const isLoading = navigation.state === 'loading';

  return (
    <>
      {isLoading && <FullScreenSpinner message={t('ui.io.loading')} />}
      <Box
        hidden={isLoading}
        sx={{ '&:not([hidden])': { display: 'contents' } }}
      >
        <Outlet />
      </Box>
    </>
  );
}
